import { render, staticRenderFns } from "./SlidyThing.vue?vue&type=template&id=725d3c2b&scoped=true&"
import script from "./SlidyThing.vue?vue&type=script&lang=js&"
export * from "./SlidyThing.vue?vue&type=script&lang=js&"
import style0 from "./SlidyThing.vue?vue&type=style&index=0&id=725d3c2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725d3c2b",
  null
  
)

export default component.exports